import {lazy} from 'react';

export const CommentsLazy = lazy(() => import(/* webpackChunkName: "comments" */ '.'));
